<div mat-dialog-content>
    <h1
        style="align-self: center; justify-self: center">
        {{ (data?.text ?? 'partialViews_dialog_confirmationDefaultText_label'  ) | translate: locale.language }}
    </h1>
</div>
<div mat-dialog-actions style="display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: 20px">
    <button mat-raised-button
            (click)="dialogRef.close(false)">
        {{ (data?.confirmationNo ?? 'partialViews_dialog_confirmationDefaultNo_button') | translate: locale.language }}
    </button>
    <button color="accent" mat-raised-button
            (click)="dialogRef.close(true)">
        {{ (data?.confirmationYes ?? 'partialViews_dialog_confirmationDefaultYes_button') | translate: locale.language }}
    </button>
</div>